module.exports = __webpack_public_path__ + "static/media/Static Data.873ff84f.svg";